import { render, staticRenderFns } from "./MsChip.vue?vue&type=template&id=4d29cbfa&lang=html"
import script from "./MsChip.vue?vue&type=script&lang=js"
export * from "./MsChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d29cbfa')) {
      api.createRecord('4d29cbfa', component.options)
    } else {
      api.reload('4d29cbfa', component.options)
    }
    module.hot.accept("./MsChip.vue?vue&type=template&id=4d29cbfa&lang=html", function () {
      api.rerender('4d29cbfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/MsChip.vue"
export default component.exports